import { search } from '@/api/experian';
import { NutsAddress } from '@/utils/address';

export type AvsOperation = 'expand' | 'refine' | 'search';
export type AvsStatus =
  | 'interactionRequired'
  | 'multipleMatches'
  | 'noMatches'
  | 'requireBuildingNumber'
  | 'requireUnitNumber'
  | 'verified';

export interface AvsSuggestion {
  key: string;
  postalCode: string;
  text: string;
  type: Omit<AvsOperation, 'search'>;
}

export interface AvsVerified {
  status: 'verified';
  address: NutsAddress;
}
export interface AvsInteractionRequired {
  status: 'interactionRequired';
  address: NutsAddress;
}

export interface AvsIncomplete {
  status: 'requireBuildingNumber' | 'requireUnitNumber';
  suggestions?: AvsSuggestion[];
}

export interface AvsMultiple {
  status: 'multipleMatches';
  suggestions: AvsSuggestion[];
}

export interface AvsNone {
  status: 'noMatches';
}

// eslint-disable-next-line max-len
export type AvsResponse =
  | AvsIncomplete
  | AvsInteractionRequired
  | AvsMultiple
  | AvsNone
  | AvsVerified;

export async function refineSuggestions(address: NutsAddress, suggestion: AvsSuggestion) {
  const verificationState = await search(address, suggestion.key, 'refine');
  return verificationState;
}

export async function selectSuggestion(address: NutsAddress, suggestion: AvsSuggestion) {
  const verificationState = await search(address, suggestion.key, 'expand');
  return verificationState;
}

export async function verifyAddress(address: NutsAddress) {
  const verificationState = await search(address);
  return verificationState;
}
